const ThankYouScreen = () => {
  return (
    <div className="min-h-screen flex items-center justify-center py-12 px-4 fade-in">
      <div className="max-w-3xl w-full space-y-10 text-center">
        <div className="space-y-8">
          <h1 className="text-5xl md:text-6xl font-bold text-[hsl(var(--text-primary))] leading-tight" style={{ letterSpacing: '-0.02em' }}>
            Perfecto, todo listo.
          </h1>
          
          <div className="space-y-6 text-base md:text-lg leading-relaxed max-w-2xl mx-auto" style={{ letterSpacing: '-0.01em' }}>
            <p className="text-[hsl(var(--text-secondary))]">
              El sistema ya está analizando tu negocio para generar un primer análisis estructurado.
            </p>
            <p className="font-semibold text-[hsl(var(--text-primary))] text-lg">
              Revisa tu bandeja de entrada (y, por si acaso, la carpeta de spam) en los próximos 2 minutos.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThankYouScreen;
